<template>
  <div>
    <div class="row no-gutters">
      <div class="col-xs-12 col-md mr-md-4">
        <div class="card-box">
          <div class="single-form">
            <el-form
              style="padding: 0;"
              label-position="top"
              label-width="100px"
              :model="centerUserForm"
              :rules="validateRules.centerUserForm"
              @validate="onCenterUserFormValidateChange"
            >
              <el-form-item label="이메일 계정">
                <el-input
                  v-model="centerUserForm.email"
                  :disabled="true"
                />
              </el-form-item>
              <el-form-item
                label="관리자 성함"
                prop="name"
              >
                <el-input v-model="centerUserForm.name" />
              </el-form-item>
              <el-form-item
                label="휴대전화번호"
                prop="phone_number"
              >
                <el-input v-model="centerUserForm.phone_number" />
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="d-md-flex justify-content-between mt-3 no-gutters">
          <div class="col" />
          <div class="col-12 col-md-8 py-3 px-5 px-md-0 form-bottom-description">
            이메일 계정 변경은 <strong>피플박스 헬프센터</strong>로 문의바랍니다.
          </div>

          <div class="col d-flex justify-content-end align-items-end">
            <div>
              <el-loading-button
                class="gray"
                :is-loading="isSavingUserForm"
                :disabled="!isCenterUserFormValidated || !isCenterUserChanged"
                @click="saveCenterUserForm"
              >
                업데이트
              </el-loading-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md ml-md-4 mt-4 mt-md-0">
        <div class="card-box">
          <div class="single-form">
            <el-form
              style="padding: 0;"
              label-position="top"
              label-width="100px"
            >
              <el-form-item label="기존 비밀번호">
                <el-input
                  v-model="passwordForm.old_password"
                  type="password"
                  placeholder="기존 비밀번호 입력"
                />
              </el-form-item>
              <el-form-item label="새 비밀번호">
                <el-input
                  v-model="passwordForm.new_password1"
                  type="password"
                  placeholder="8자리 이상의 영문/숫자를 조합해주세요"
                />
              </el-form-item>
              <el-form-item label="새 비밀번호 확인">
                <el-input
                  v-model="passwordForm.new_password2"
                  type="password"
                  placeholder="8자리 이상의 영문/숫자를 조합해주세요"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3 no-gutters">
          <div class="col" />
          <div class="col-6" />
          <div class="col d-flex justify-content-end">
            <div>
              <el-button
                class="gray"
                @click="saveNewPassword"
              >
                비밀번호 재설정
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computedGetters } from '@/utils/vuex-helper';
import ElLoadingButton from '@/components/el-loading-button';
import { validateName, validatePhoneNum } from '@/utils/form-validate-rules';
import { fiflboxApi } from '@/utils/api';

export default {
  name: 'CenterAccount',
  components: { ElLoadingButton },
  data() {
    return {
      validateRules: {
        centerUserForm: {
          name: [{ validator: validateName, trigger: 'change' }],
          phone_number: [{ validator: validatePhoneNum, trigger: 'change' }]
        }
      },
      centerUserForm: {
        name: '',
        email: '',
        phone_number: ''
      },
      passwordForm: {
        old_password: '',
        new_password1: '',
        new_password2: ''
      },
      isFormValid: {
        centerUserForm: {
          name: false,
          phone_number: false
        }
      },
      isSavingUserForm: false
    };
  },
  computed: {
    ...computedGetters(['centerAccount']),
    isCenterUserFormValidated() {
      return Object.values(this.isFormValid.centerUserForm).every(i => i);
    },
    isCenterUserChanged() {
      return (
        this.centerUserForm.name != this.centerAccount.user.name ||
        this.centerUserForm.phone_number != this.centerAccount.user.phone_number
      );
    }
  },
  async created() {
    await this.$store.dispatch('syncCenterAccount');
    this.centerUserForm = _.cloneDeep(
      this.$store.getters.getCenterAccount.user
    );
  },
  methods: {
    onCenterUserFormValidateChange(key, isValidated) {
      this.isFormValid.centerUserForm[key] = isValidated;
    },
    async saveCenterUserForm() {
      this.isSavingUserForm = true;

      try {
        await this.$store.dispatch('updateCenterUser', this.centerUserForm);
        await this.$store.dispatch('syncCenterAccount');
      } catch (err) {
        console.error(err);
      }

      this.$message('기본 정보가 업데이트됐습니다.');
      this.isSavingUserForm = false;
    },
    async saveNewPassword() {
      try {
        let form = Object.assign(this.passwordForm, {});

        await fiflboxApi.v2.postPasswordChange(form);

        this.$alert(
          '비밀번호가 변경되었습니다. 다시 로그인해주세요.',
          '비밀번호 재설정 완료',
          {
            confirmButtonText: '확인',
            showClose: false,
            customClass: 'fifl-message-box',
            confirmButtonClass: 'gray'
          }
        );
        await this.$store.dispatch('timeTable/resetTimeTableInfos');
        await this.$tokenStorage.deleteToken();
        this.$router.replace('/').catch(() => {});
      } catch (err) {
        let message =
          '비밀번호 변경을 실패하였습니다. 기존 비밀번호를 다시 한번 확인해주세요.';

        if (err.response.data.error_code) {
          message = err.response.data.error_detail;
        }

        this.$alert(message, '비밀번호 재설정 실패', {
          confirmButtonText: '확인',
          showClose: false,
          customClass: 'fifl-message-box',
          confirmButtonClass: 'gray'
        });
      }
    }
  }
};
</script>

<style lang="scss">
</style>
